<template>
<div>
    <boton-atras nombre_ruta="otros"></boton-atras>
    <div class="row">
        <div class="col-md  mt-1 order-2 order-sm-2 order-md-1 order-lg-1">
            <div>
                <h6 class="subtitulo mt-5">Información Contable</h6>
                <div class="lineaNegra"></div><div class="mt-1 mb-2 lineaNegra2"></div>
                <h6 class="mt-3">Estados de Situación Financiera, de Actividades, Analítico del Activo y Relación de Bienes que componen su patrimonio.(Artículos 47 y 51 LGCG)</h6>
            </div>
            <div class="my-4 ancho-select">
                <nav>
                    <div class="nav nav-tabs" id="nav-tab" role="tablist">
                        <a class="nav-link active" id="nav-home-tab" data-toggle="tab" href="#nav-home" role="tab" aria-controls="nav-home" aria-selected="true">2016</a>
                        <a class="nav-link" id="nav-profile-tab" data-toggle="tab" href="#nav-profile" role="tab" aria-controls="nav-profile" aria-selected="false">2015</a>
                        <a class="nav-link" id="nav-contact-tab" data-toggle="tab" href="#nav-contact" role="tab" aria-controls="nav-contact" aria-selected="false">2014</a>
                    </div>
                </nav>
                <div class="tab-content" id="nav-tabContent">
                    <div class="tab-pane fade show active py-4" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab"> 
                        <a :href="urlServe+'Foprovep/informacion/armonizacion/2016/3er-trimestre.pdf'" target="_blank">
                            <div class="mb-2">
                                <div class="title_document" style="display:flex; justify-content:space-between;">
                                    <div class="col-8">
                                        <h5> Tercer Trimestre </h5>
                                        <small class="text-muted">Formato PDF, Tamaño: 2,080 Kb.</small>
                                    </div>
                                    <div class="col-3">
                                        <small class="text-muted">Descargar <i class='bx bx-download icono-down'></i></small>
                                    </div> 
                                </div> 
                            </div>
                        </a> 
                        <a :href="urlServe+'Foprovep/informacion/armonizacion/2016/2do-trimestre.pdf'" target="_blank">
                            <div class="mb-2">
                                <div class="title_document" style="display:flex; justify-content:space-between;">
                                    <div class="col-8">
                                        <h5> Segundo Trimestre </h5>
                                        <small class="text-muted">Formato PDF, Tamaño: 2,061 Kb.</small>
                                    </div>
                                    <div class="col-3">
                                        <small class="text-muted">Descargar <i class='bx bx-download icono-down'></i></small>
                                    </div> 
                                </div> 
                            </div>
                        </a>  
                        <a :href="urlServe+'Foprovep/informacion/armonizacion/2016/1er-trimestre.pdf'" target="_blank">
                            <div class="mb-2">
                                <div class="title_document" style="display:flex; justify-content:space-between;">
                                    <div class="col-8">
                                        <h5> Primer Trimestre </h5>
                                        <small class="text-muted">Formato PDF, Tamaño: 2,100 Kb.</small>
                                    </div>
                                    <div class="col-3">
                                        <small class="text-muted">Descargar <i class='bx bx-download icono-down'></i></small>
                                    </div> 
                                </div> 
                            </div>
                        </a>  
                    </div>
                    <div class="tab-pane fade py-4" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                        <a :href="urlServe+'Foprovep/informacion/armonizacion/2015/4to-trimestre.pdf'" target="_blank">
                            <div class="mb-2">
                                <div class="title_document" style="display:flex; justify-content:space-between;">
                                    <div class="col-8">
                                        <h5> Cuarto Trimestre </h5>
                                        <small class="text-muted">Formato PDF, Tamaño: 2,061 Kb.</small>
                                    </div>
                                    <div class="col-3">
                                        <small class="text-muted">Descargar <i class='bx bx-download icono-down'></i></small>
                                    </div> 
                                </div> 
                            </div>
                        </a>  
                        <a :href="urlServe+'Foprovep/informacion/armonizacion/2015/3er-trimestre.pdf'" target="_blank">
                            <div class="mb-2">
                                <div class="title_document" style="display:flex; justify-content:space-between;">
                                    <div class="col-8">
                                        <h5> Tercer Trimestre </h5>
                                        <small class="text-muted">Formato PDF, Tamaño: 4,690 Kb.</small>
                                    </div>
                                    <div class="col-3">
                                        <small class="text-muted">Descargar <i class='bx bx-download icono-down'></i></small>
                                    </div> 
                                </div> 
                            </div>
                        </a> 
                        <a :href="urlServe+'Foprovep/informacion/armonizacion/2015/2do-trimestre.pdf'" target="_blank">
                            <div class="mb-2">
                                <div class="title_document" style="display:flex; justify-content:space-between;">
                                    <div class="col-8">
                                        <h5> Segundo Trimestre </h5>
                                        <small class="text-muted">Formato PDF, Tamaño: 4,114 Kb.</small>
                                    </div>
                                    <div class="col-3">
                                        <small class="text-muted">Descargar <i class='bx bx-download icono-down'></i></small>
                                    </div> 
                                </div> 
                            </div>
                        </a>  
                        <a :href="urlServe+'Foprovep/informacion/armonizacion/2015/1er-trimestre.pdf'" target="_blank">
                            <div class="mb-2">
                                <div class="title_document" style="display:flex; justify-content:space-between;">
                                    <div class="col-8">
                                        <h5> Primer Trimestre </h5>
                                        <small class="text-muted">Formato PDF, Tamaño: 4,113 Kb.</small>
                                    </div>
                                    <div class="col-3">
                                        <small class="text-muted">Descargar <i class='bx bx-download icono-down'></i></small>
                                    </div> 
                                </div> 
                            </div>
                        </a>  
                    </div>
                    <div class="tab-pane fade my-4" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
                        <a :href="urlServe+'Foprovep/informacion/armonizacion/ENERO.pdf'" target="_blank">
                            <div class="mb-2">
                                <div class="title_document" style="display:flex; justify-content:space-between;">
                                    <div class="col-8">
                                        <h5> Enero </h5>
                                        <small class="text-muted">Formato PDF, Tamaño: 3,535 Kb.</small>
                                    </div>
                                    <div class="col-3">
                                        <small class="text-muted">Descargar <i class='bx bx-download icono-down'></i></small>
                                    </div> 
                                </div> 
                            </div>
                        </a> 
                        <a :href="urlServe+'Foprovep/informacion/armonizacion/FEBRERO.pdf'" target="_blank">
                            <div class="mb-2">
                                <div class="title_document" style="display:flex; justify-content:space-between;">
                                    <div class="col-8">
                                        <h5> Febrero </h5>
                                        <small class="text-muted">Formato PDF, Tamaño: 3,437 Kb.</small>
                                    </div>
                                    <div class="col-3">
                                        <small class="text-muted">Descargar <i class='bx bx-download icono-down'></i></small>
                                    </div> 
                                </div> 
                            </div>
                        </a>  
                        <a :href="urlServe+'Foprovep/informacion/armonizacion/MARZO.pdf'" target="_blank">
                            <div class="mb-2">
                                <div class="title_document" style="display:flex; justify-content:space-between;">
                                    <div class="col-8">
                                        <h5> Marzo</h5>
                                        <small class="text-muted">Formato PDF, Tamaño: 3,456 Kb.</small>
                                    </div>
                                    <div class="col-3">
                                        <small class="text-muted">Descargar <i class='bx bx-download icono-down'></i></small>
                                    </div> 
                                </div> 
                            </div>
                        </a>  
                        <a :href="urlServe+'Foprovep/informacion/armonizacion/ABRIL.pdf'" target="_blank">
                            <div class="mb-2">
                                <div class="title_document" style="display:flex; justify-content:space-between;">
                                    <div class="col-8">
                                        <h5> Abril</h5>
                                        <small class="text-muted">Formato PDF, Tamaño: 3,271 Kb.</small>
                                    </div>
                                    <div class="col-3">
                                        <small class="text-muted">Descargar <i class='bx bx-download icono-down'></i></small>
                                    </div> 
                                </div> 
                            </div>
                        </a>  
                        <a :href="urlServe+'Foprovep/informacion/armonizacion/MAYO.pdf'" target="_blank">
                            <div class="mb-2">
                                <div class="title_document" style="display:flex; justify-content:space-between;">
                                    <div class="col-8">
                                        <h5> Mayo </h5>
                                        <small class="text-muted">Formato PDF, Tamaño: 4,317 Kb.</small>
                                    </div>
                                    <div class="col-3">
                                        <small class="text-muted">Descargar <i class='bx bx-download icono-down'></i></small>
                                    </div> 
                                </div> 
                            </div>
                        </a> 
                        <a :href="urlServe+'Foprovep/informacion/armonizacion/JUNIO.pdf'" target="_blank">
                            <div class="mb-2">
                                <div class="title_document" style="display:flex; justify-content:space-between;">
                                    <div class="col-8">
                                        <h5> Junio </h5>
                                        <small class="text-muted">Formato PDF, Tamaño: 5,823 Kb.</small>
                                    </div>
                                    <div class="col-3">
                                        <small class="text-muted">Descargar <i class='bx bx-download icono-down'></i></small>
                                    </div> 
                                </div> 
                            </div>
                        </a>  
                        <a :href="urlServe+'Foprovep/informacion/armonizacion/JULIO.pdf'" target="_blank">
                            <div class="mb-2">
                                <div class="title_document" style="display:flex; justify-content:space-between;">
                                    <div class="col-8">
                                        <h5>Julio</h5> <small class="text-muted">Formato PDF, Tamaño: 5,548 Kb.</small>
                                    </div>
                                    <div class="col-3">
                                        <small class="text-muted">Descargar <i class='bx bx-download icono-down'></i></small>
                                    </div> 
                                </div> 
                            </div>
                        </a>
                        <a :href="urlServe+'Foprovep/informacion/armonizacion/AGOSTO.pdf'" target="_blank">
                            <div class="mb-2">
                                <div class="title_document" style="display:flex; justify-content:space-between;">
                                    <div class="col-8">
                                        <h5> Agosto</h5>
                                        <small class="text-muted">Formato PDF, Tamaño: 5,726 Kb.</small>
                                    </div>
                                    <div class="col-3">
                                        <small class="text-muted">Descargar <i class='bx bx-download icono-down'></i></small>
                                    </div> 
                                </div> 
                            </div>
                        </a> 
                        <a :href="urlServe+'Foprovep/informacion/armonizacion/SEPTIEMBRE.pdf'" target="_blank">
                            <div class="mb-2">
                                <div class="title_document" style="display:flex; justify-content:space-between;">
                                    <div class="col-8">
                                        <h5> Septiembre </h5>
                                        <small class="text-muted">Formato PDF, Tamaño: 5,880 Kb.</small>
                                    </div>
                                    <div class="col-3">
                                        <small class="text-muted">Descargar <i class='bx bx-download icono-down'></i></small>
                                    </div> 
                                </div> 
                            </div>
                        </a>  
                        <a :href="urlServe+'Foprovep/informacion/armonizacion/ANUAL.pdf'" target="_blank">
                            <div class="mb-2">
                                <div class="title_document" style="display:flex; justify-content:space-between;">
                                    <div class="col-8">
                                        <h5> Anual</h5>
                                        <small class="text-muted">Formato PDF, Tamaño: 44,390 Kb.</small>
                                    </div>
                                    <div class="col-3">
                                        <small class="text-muted">Descargar <i class='bx bx-download icono-down'></i></small>
                                    </div> 
                                </div> 
                            </div>
                        </a>  
                    </div>
                </div>
            </div>
            <div class="mb-5">
                <h5 class="subtitulo">Inventario de Bienes</h5>
                <h6>2015 - Primer Trimestre</h6>
                <a :href="urlServe+'Foprovep/informacion/armonizacion/inventario-bienes/2015/1241.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                            <div class="col-8">
                                <h5> 1241-Mobilario y Equipo de Administración </h5>
                            </div>
                            <div class="col-3">
                                <small class="text-muted">Descargar <i class='bx bx-download icono-down'></i></small>
                            </div> 
                        </div> 
                    </div>
                </a> 
                <a :href="urlServe+'Foprovep/informacion/armonizacion/inventario-bienes/2015/1244.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                            <div class="col-8">
                                <h5>1244-Vehículos y Equipo de Transporte</h5>
                            </div>
                            <div class="col-3">
                                <small class="text-muted">Descargar <i class='bx bx-download icono-down'></i></small>
                            </div> 
                        </div> 
                    </div>
                </a> 
                <h6 class="mt-3">2014 </h6>
                <a :href="urlServe+'Foprovep/informacion/armonizacion/inventario-bienes/2014/1241.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                            <div class="col-8">
                                <h5>1241-Mobilario y Equipo de Administración </h5>
                            </div>
                            <div class="col-3">
                                <small class="text-muted">Descargar <i class='bx bx-download icono-down'></i></small>
                            </div> 
                        </div> 
                    </div>
                </a> 
                <a :href="urlServe+'Foprovep/informacion/armonizacion/inventario-bienes/2014/1244.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                            <div class="col-8">
                                <h5>1244-Vehículos y Equipo de Transporte</h5>
                            </div>
                            <div class="col-3">
                                <small class="text-muted">Descargar <i class='bx bx-download icono-down'></i></small>
                            </div> 
                        </div> 
                    </div>
                </a> 
            </div>
            
        </div>
                
        <div class="col-md order-1 order-sm-1 order-md-2 order-lg-2 ">
            <div class="row margenes">
                <div class="sec_imagen"> 
                    <img src="@/assets/imagenes/reglamentoInterno.png" alt="">  
                </div>
            </div>  
        </div>
    </div>
</div>
</template>

<script>
import botonAtras from './../../button-atras'
export default {
    data: function(){
        return{
        }
    },
    components:{
        botonAtras,
    },
    mounted(){
        window.scrollTo(0, 0);
    }
}
</script>

<style scoped>
    /* .title_document { 
        padding: .8rem 1rem;             
        width: 100%;
        height: auto;
        border: 1px solid#dfdfdf ;
        border-radius: 5px;
        border-left: 3px solid #621132;

        display: flex;
        justify-content: space-between;
        align-items: center !important;
    } 

    .title_document:hover{
        box-shadow: 3px 8px 17px -13px rgba(0,0,0,0.75) !important;
    }

    .descargar{
        font-size: 0.9rem;
        color: #6c757d !important;
    }

    .subtitulo {
        font-weight: 400;
        font-size: 1.8rem;
        margin-top: 1rem;
    }
    .subtitulo2{
        font-weight: 400;
        font-size: 1.2rem;
        margin-top: .5rem;
        margin-bottom: 1rem ;
    }
    .title_document h5{
        font-size: 0.9rem;
        font-weight: 400;
        line-height: 20px;
    }

    .sec_imagen{ 
        width:85% !important;
        background-color: #560F2C;
    }

    a{
        text-decoration: none !important;
        color: #212529;
    }
    a:hover{ color:#212529 !important; }

    .margenes{
        display: flex;
        justify-content: flex-end;
    }
    .card-width{ width: 90%; }
    .card{width: 100%;}
    
    .form-control-lg {
        font-size: 1rem;
        border-radius: .4rem;
    }


@media only screen and (max-device-width : 900px) {

    .container{
        padding-right: 1% !important;
        padding-left: 1% !important;
    }
    .title_document{
        padding: .5rem 1rem .5rem .1rem;
        line-height: 20px;
    }

    .margenes{ justify-content: space-around; }
    .card-width{ width: 95%; }

    .subtitulo2{ font-size: 1rem; }

    .sec_imagen{ margin-top: 0rem; }
} */
















</style>